var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetDoctorVisit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vector",
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    viewBox: "0 0 457.54 470.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#92e3a9",
    d: "m420.28,129.69S339.88,13.94 239.5,1.66C150.89,-9.18 68.64,33.19 57.19,124.75c-4.08,32.63 -11.34,68.72 -24.24,98.48 -14.46,33.38 -39.16,61.17 -20.24,125.34 18.92,64.17 98.76,122.11 156.81,121.97 58.05,-0.15 112.58,-52.89 157.57,-100.88 44.99,-47.99 188.27,-93.09 93.19,-239.97Z",
    strokeWidth: 0,
    id: "path_0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m420.28,129.69S339.88,13.94 239.5,1.66C150.89,-9.18 68.64,33.19 57.19,124.75c-4.08,32.63 -11.34,68.72 -24.24,98.48 -14.46,33.38 -39.16,61.17 -20.24,125.34 18.92,64.17 98.76,122.11 156.81,121.97 58.05,-0.15 112.58,-52.89 157.57,-100.88 44.99,-47.99 188.27,-93.09 93.19,-239.97Z",
    strokeOpacity: 0.7,
    strokeWidth: 0,
    id: "path_1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M97.83,162.04l-75.07,0l0.76,-14.49l75.07,0l-0.76,14.49z",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M97.83,182.33l-75.07,0l0.76,-14.49l75.07,0l-0.76,14.49z",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M97.83,202.62l-75.07,0l0.76,-14.49l75.07,0l-0.76,14.49z",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M97.83,222.91l-75.07,0l0.76,-14.49l75.07,0l-0.76,14.49z",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M97.83,243.2l-75.07,0l0.76,-14.49l75.07,0l-0.76,14.49z",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M97.83,263.49l-75.07,0l0.76,-14.49l75.07,0l-0.76,14.49z",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M97.83,283.78l-75.07,0l0.76,-14.49l75.07,0l-0.76,14.49z",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M97.83,304.07l-75.07,0l0.76,-14.49l75.07,0l-0.76,14.49z",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M97.83,324.36l-75.07,0l0.76,-14.49l75.07,0l-0.76,14.49z",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_10"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M97.83,344.65l-75.07,0l0.76,-14.49l75.07,0l-0.76,14.49z",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_11"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M97.83,364.95l-75.07,0l0.76,-14.49l75.07,0l-0.76,14.49z",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_12"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M177.21,162.04l-75.07,0l0.76,-14.49l75.07,0l-0.76,14.49z",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_13"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M177.21,182.33l-75.07,0l0.76,-14.49l75.07,0l-0.76,14.49z",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_14"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M177.21,202.62l-75.07,0l0.76,-14.49l75.07,0l-0.76,14.49z",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_15"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M177.21,222.91l-75.07,0l0.76,-14.49l75.07,0l-0.76,14.49z",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_16"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M177.21,243.2l-75.07,0l0.76,-14.49l75.07,0l-0.76,14.49z",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_17"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M177.21,263.49l-75.07,0l0.76,-14.49l75.07,0l-0.76,14.49z",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_18"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M177.21,283.78l-75.07,0l0.76,-14.49l75.07,0l-0.76,14.49z",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_19"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M177.21,304.07l-75.07,0l0.76,-14.49l75.07,0l-0.76,14.49z",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_20"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M177.21,324.36l-75.07,0l0.76,-14.49l75.07,0l-0.76,14.49z",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_21"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M177.21,344.65l-75.07,0l0.76,-14.49l75.07,0l-0.76,14.49z",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_22"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M177.21,364.95l-75.07,0l0.76,-14.49l75.07,0l-0.76,14.49z",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_23"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M311.14,177.03h96.89v73.31h-96.89z",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_24"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M316.39,183.09h86.38v61.2h-86.38z",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_25"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M344.56,192.74L374.61,192.74",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_26"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M325.1,201.62L394.07,201.62",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_27"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M340.46,219.37L378.7,219.37",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_28"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M325.78,237.12L340.8,237.12",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_29"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M378.36,237.12L393.38,237.12",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_30"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M363.03,265.8h71.32v53.97h-71.32z",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_31"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M366.9,270.26h63.58v45.05h-63.58z",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_32"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M387.63,277.36L409.75,277.36",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_33"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M373.31,283.9L424.07,283.9",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_34"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M384.62,296.96L412.76,296.96",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_35"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M373.81,310.03L384.87,310.03",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_36"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    fillOpacity: 0.3,
    d: "M412.51,310.03L423.57,310.03",
    strokeOpacity: 0.3,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_37"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "M457.04,449.66L0.5,449.66",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_38"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "M457.04,459.22L0.5,459.22",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_39"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m432.03,344.21h-96.81c-3.16,0 -5.84,2.32 -6.29,5.44l-14.47,99.03h115.11l8.79,-97.54c0.34,-3.72 -2.6,-6.93 -6.33,-6.93Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_40"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m300.98,328.05s-26.19,12.99 -35.18,16.59c-8.99,3.6 -11.19,5.2 -11.99,7.4 -0.8,2.2 -35.78,57.17 -39.78,62.17 -4,5 -12.59,15.79 -11.39,23.19 1.2,7.4 10.79,13.79 19.99,13.59 9.19,-0.2 14.99,-2 15.99,-4.6 1,-2.6 26.39,-47.97 26.39,-47.97l8,50.57h102.14s8,-69.16 8,-79.36 2,-22.19 -2.2,-24.79 -21.59,-8.6 -34.38,-12.79c-12.79,-4.2 -16.79,-5 -19.79,-5s-25.79,1 -25.79,1Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_41"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m298.18,328.45s-3.4,6.4 -3.6,11.59c-0.2,5.2 -1,14.79 -4,20.59s-5.2,8.99 -3.6,8.4c1.6,-0.6 10.79,-10.79 11.79,-12.99s2.6,2 2.6,2c0,0 -3,8.6 -3.4,9.8 -0.4,1.2 12.59,17.79 12.59,17.79 0,0 11.19,-8.8 13.79,-10.79 2.6,-2 1.8,-3.6 2,-6.2 0.2,-2.6 1,-6.4 2.4,-8.6 1.4,-2.2 5.4,6.4 8.2,10.39 2.8,4 5.6,5.4 5.2,2.4 -0.4,-3 -1.8,-8.8 -2.8,-18.99 -1,-10.19 -0.8,-22.39 -3.4,-26.19 -2.6,-3.8 -16.24,-4.55 -25.19,-5.2 -8.95,-0.64 -12.59,6 -12.59,6Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_42"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "M257.8,362.45l7.2,35.96l-9.29,-23.91",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_43"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m299.18,338.04s2.8,15.59 5.4,27.58c2.6,11.99 6,19.99 6,19.99 0,0 13.19,-22.19 16.99,-33.78 3.8,-11.59 5,-19.59 5,-19.59h-33.38v5.8Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_44"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#92e3a9",
    d: "m313.77,343.44l-7.2,8.99 5,9.6 -4.92,11.92c2.04,7.22 3.92,11.67 3.92,11.67 0,0 4.11,-6.92 8.41,-15.05l-3.61,-8.34 4.4,-9.99 -6,-8.8Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_45"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m299.18,332.25v5.8s1.93,10.76 4.07,21.27l10.12,-10.68 10.66,11.82c1.46,-3.14 2.71,-6.13 3.53,-8.62 3.8,-11.59 5,-19.59 5,-19.59h-33.38Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_46"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m212.03,420.12s18.67,-6.82 28.74,9.78",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_47"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m241.09,424.78s-10.43,2.36 -16.02,11.25c-5.6,8.89 5.76,9.88 8.89,9.88s6.09,-2.09 6.26,-3.19 4.28,-11.63 4.11,-14.09c-0.17,-2.47 -2.02,-3.73 -3.23,-3.84Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_48"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m236.29,428.46s-5.76,5.03 -5.37,6.98c0.39,1.95 8.95,9.71 10.6,8.6 1.65,-1.11 1.58,-2.69 1.11,-3.42 -0.47,-0.73 -6.34,-12.15 -6.34,-12.15Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_49"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m230.92,435.43s-3.39,3.61 -2.28,5.26c1.11,1.65 8.87,5.85 10.88,4.59 2.01,-1.26 0.7,-2.58 0.7,-2.58l-9.29,-7.28Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_50"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M250.8,428.26l-6.94,-1.2l1.64,9.99l7.08,0.22l-1.78,-9.01z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_51"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m238.32,412.56l8.13,28.49 3.95,3.59 -0,-5.07 -8.6,-28.04c-0.3,-0.98 -1.35,-1.52 -2.32,-1.18h0c-0.91,0.31 -1.42,1.29 -1.16,2.21Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_52"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m241.09,424.78s-4.79,2.81 -4.31,4.93 5.65,12.1 7.53,12.23c1.87,0.13 3,-1.05 2.73,-3.16 -0.27,-2.11 -2.04,-9.97 -3.17,-11.72s-1.3,-2.39 -2.77,-2.28Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_53"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m250.8,428.26s5.11,0.65 6.01,2.21c0.89,1.56 -2.69,7.77 -3.82,9.2s-3.18,1.36 -3.24,-2.24c-0.06,-3.6 1.05,-9.16 1.05,-9.16Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_54"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m223.17,440.29h56.06c3.27,0 5.91,2.65 5.91,5.91h0c0,2.77 -2.25,5.02 -5.02,5.02h-56.17c-2.54,0 -4.6,-2.06 -4.6,-4.6v-2.52c0,-2.11 1.71,-3.81 3.81,-3.81Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_55"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m322.97,427.4s-14.59,-1.6 -18.19,-2.8c-3.6,-1.2 -9.4,-2.2 -11.39,-0.6 -2,1.6 -11.79,12.99 -11.99,14.39s-2.2,6 -1.2,7.2c1,1.2 3,1.8 3,1.8 0,0 12.99,3.6 14.39,3.8 1.4,0.2 14.79,-0.4 14.79,-0.4l7,-2.6 9.8,-0.2s0.2,3.2 0.4,-4.6 -6.6,-15.99 -6.6,-15.99Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_56"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m283.19,447.39s0.2,-4.6 1.2,-6.6c1,-2 12.39,-12.19 12.39,-12.19",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_57"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m286.98,448.58s2,-5 2.8,-5.4c0.8,-0.4 10.19,-6.4 10.19,-6.4",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_58"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m293.78,449.98s0.4,-2 1.4,-2.4c1,-0.4 9.4,-4.2 9.4,-4.2",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_59"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "M302.78,450.98l3.8,-1l-0.4,-1.8l-4,1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_60"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m368.74,363.03s-10.59,22.19 -9.99,29.98c0.6,7.8 3.2,20.79 3.2,20.79 0,0 -16.79,6.6 -22.59,8.99 -5.8,2.4 -16.39,4.6 -16.39,4.6l5.4,21.19 -0.8,2.2h58.17s4.4,-0.8 5.2,-1.8c0.8,-1 1.6,-1.4 2,-4.6 0.4,-3.2 3,-31.18 2.4,-38.98 -0.6,-7.8 -8.8,-48.37 -9.8,-52.57 -1,-4.2 -2.8,-7 -4.6,-8 -1.8,-1 -9.6,-1.8 -9.6,-1.8",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_61"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m363.34,414.2s15.39,0.8 22.99,5.6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_62"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m366.14,412.2s10.79,-0.6 16.59,1.2",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_63"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m363.14,362.43s-5.4,12.59 -5.6,17.39c-0.2,4.8 -0.6,7.6 -0.6,7.6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_64"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m338.56,329.05s12.19,17.39 2.4,65.76",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    id: "path_65"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m346.75,396.21c0,-3.31 -2.68,-6 -6,-6s-6,2.68 -6,6 2.68,6 6,6 6,-2.68 6,-6Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_66"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m296.98,330.85s-6.2,4 -7.2,20.19",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    id: "path_67"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m298.36,375.57c-1.51,10.93 -3.57,22.65 -4.03,25.22 -0.99,5.49 -7.54,7.42 -11.73,5.62",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    id: "path_68"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m282.7,376.29c-1.37,-6.12 -2.21,-11.44 -1.91,-13.86 1.4,-11.19 8.99,-11.39 8.99,-11.39 0,0 8.99,1.2 9.6,10.79 0.2,3.2 -0.27,8.27 -1.02,13.73",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    id: "path_69"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m299.58,405.61s-4.2,2.4 -7,0.8c-1.89,-1.08 -7.04,-17.36 -9.89,-30.12",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    id: "path_70"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m299.4,404.13l1.66,-0.72c0.79,-0.34 1.72,0.02 2.06,0.82l0.02,0.05c0.34,0.79 -0.02,1.72 -0.82,2.06l-1.66,0.72c-0.79,0.34 -1.72,-0.02 -2.06,-0.82l-0.02,-0.05c-0.34,-0.79 0.02,-1.72 0.82,-2.06Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_71"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m281.57,403.59l1.55,0.93c0.74,0.45 0.98,1.41 0.54,2.15l-0.03,0.04c-0.44,0.74 -1.41,0.98 -2.15,0.54l-1.55,-0.93c-0.74,-0.45 -0.98,-1.41 -0.54,-2.15l0.03,-0.04c0.45,-0.74 1.41,-0.98 2.15,-0.54Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_72"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m289.78,282.47s-3.2,7.6 -2.6,12.39c0.6,4.8 7,9.99 7,9.99 0,0 2.2,-21.39 2.2,-22.19s-4,-2.6 -6.6,-0.2Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_73"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "M287.49,309.67L291.74,306.7",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    id: "path_74"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m292.18,283.87s-0.8,21.19 -0.4,25.19c0.4,4 2,16.79 3.4,20.79 1.4,4 6,16.79 9.6,18.19 3.6,1.4 10.79,2.4 13.19,0.8 2.4,-1.6 11.19,-7.6 13.59,-13.39s2.8,-10.59 2.8,-10.59c0,0 6.4,-3 7.6,-10.59 1.2,-7.6 -2,-9.8 -2,-9.8l0.2,-13.19s-2.2,-9.19 -8,-14.19c-5.8,-5 -12.59,-5.4 -19.59,-1.6 -7,3.8 -20.39,8.4 -20.39,8.4Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_75"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m329.76,282.67s0.2,-5.2 -4.8,-3.4c-5,1.8 -6.2,5.2 -13.59,8.2 -7.4,3 -17.19,-0.4 -20.59,-2.4 -3.4,-2 -5.8,-4.8 -1.2,-9.99 4.6,-5.2 15.39,-10.39 26.99,-10.39s20.59,9.6 24.39,13.59c3.8,4 4.4,8.99 3,12.59 -1.4,3.6 -4,13.59 -4,13.59 0,0 -1.6,-0.2 -2.2,2.2s-0.4,5 -3,5.2c-2.6,0.2 -2.4,-6.8 -2.4,-6.8 0,0 -6.4,-2 -7.2,-6.6 -0.8,-4.6 4.6,-11.39 4.6,-15.79Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_76"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m305.98,312.92l-18.49,-3.26 1.08,8.29c0.14,1.07 0.96,1.92 2.03,2.08l11.23,1.77c1.28,0.2 2.5,-0.64 2.76,-1.92l1.39,-6.97Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    id: "path_77"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m309.32,313.28l21.44,-0.62 -2.1,7.76c-0.27,1 -1.3,1.7 -2.54,1.72l-13.01,0.18c-1.49,0.02 -2.79,-0.95 -2.94,-2.2l-0.86,-6.83Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    id: "path_78"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "M305.98,312.92L309.32,313.28",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    id: "path_79"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M330.76,312.66L337.76,306.66",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    id: "path_80"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m312.17,310.86s6,-4.6 11.59,-1.8",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    id: "path_81"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m303.18,309.86s-4.6,-5 -9.8,-1.6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    id: "path_82"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m304.38,327.25s-1,4.2 0,5c1,0.8 4.2,1.4 5.6,1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_83"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m301.38,335.45s4,3 7.8,3.2c3.8,0.2 8.2,-2.6 8.2,-2.6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_84"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m316.17,315.06s2.4,2.8 6.4,-0.2",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_85"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m296.48,313.82s1.99,3.1 6.36,0.68",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_86"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m172.45,282.65s1.27,19.05 0.32,20.64 -2.86,4.76 -2.86,4.76c0,0 1.27,13.65 -1.27,15.24 -2.54,1.59 -6.35,1.9 -6.35,1.9 0,0 -2.54,10.16 -3.49,11.43 -0.95,1.27 -6.67,5.4 -8.57,6.03s-7.94,0.95 -22.23,-7.62c-14.29,-8.57 -19.69,-11.43 -19.37,-16.19 0.32,-4.76 0.95,-10.16 0.95,-10.16 0,0 1.59,-22.86 4.45,-29.85s39.06,-10.8 46.99,-8.89c7.94,1.9 11.43,12.7 11.43,12.7Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_87"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m135.61,314.09l2.22,1.59s-1.9,7.62 -0.95,11.11",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_88"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m167.36,307.71c-0.32,1.45 -1.09,2.52 -1.71,2.38 -0.62,-0.14 -0.87,-1.43 -0.54,-2.88 0.32,-1.45 1.09,-2.52 1.71,-2.38 0.62,0.14 0.87,1.43 0.54,2.88Z",
    strokeWidth: 0,
    id: "path_89"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m164.12,301.88s3.46,-3.46 6.35,-0.19",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_90"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m159.74,280.11s4.13,7.62 3.81,9.21c-0.32,1.59 -13.34,5.4 -13.34,5.4 0,0 -1.27,7.62 -3.17,8.57l-1.9,0.95s-1.59,-1.9 -3.81,-6.67c-2.22,-4.76 -5.4,-6.03 -8.89,-1.27 -3.49,4.76 -0.63,15.88 1.27,16.83l1.9,0.95s-1.59,1.59 -7.62,2.54c-6.03,0.95 -10.48,2.22 -14.92,0.95 -4.45,-1.27 -10.8,-13.34 -13.02,-28.9s4.76,-28.9 13.97,-33.02c9.21,-4.13 30.17,-0.32 31.75,0.63 1.59,0.95 12.38,-4.13 18.74,-0.95 6.35,3.17 6.03,6.67 7.62,8.89 1.59,2.22 9.84,-0.63 10.48,7.3 0.63,7.94 -2.54,12.7 -6.67,13.34 -4.13,0.63 -16.19,-4.76 -16.19,-4.76Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_91"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#92e3a9",
    d: "m84.55,329.96s-30.43,16.23 -36.23,19.42c-5.8,3.19 -6.67,6.09 -6.96,8.98 -0.29,2.9 0,100.86 0,100.86h164.32s-24.92,-74.77 -25.79,-83.18c-0.87,-8.4 -2.61,-23.18 -4.93,-24.92s-35.07,-16.23 -35.07,-16.23c0,0 -7.82,-8.4 -26.37,-8.4s-28.98,3.48 -28.98,3.48Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_92"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m103.4,389.6c0.86,0.34 1.73,0.65 2.6,0.94",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_93"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m70.93,362.71s11.99,16.75 28.39,25.04",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_94"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m81.37,382.13s6.67,6.67 20.58,10.43",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_95"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m163.94,358.11c-4.63,5.26 -11.15,13.67 -13.31,21.41",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_96"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m168.89,352.86s-0.92,0.89 -2.36,2.41",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_97"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m152.37,370.25s-4.35,8.4 -5.22,13.62",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_98"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#92e3a9",
    d: "m82.82,331.41s16.81,-0.58 32.75,-0.29c15.94,0.29 26.37,5.22 26.37,5.22 0,0 -9.56,-11.59 -13.91,-14.2s-17.68,-6.96 -28.69,-3.48c-11.01,3.48 -16.52,12.75 -16.52,12.75Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_99"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m35.02,459.15l-15.32,-58.73c-0.63,-3.05 1.7,-5.9 4.81,-5.9h121.89c2.31,0 4.3,1.61 4.8,3.86l13.53,60.84",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    id: "path_100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetDoctorVisit);
export default __webpack_public_path__ + "static/media/get_doctor_visit.332db52b57b9a4e5934f744fc8f73b74.svg";
export { ForwardRef as ReactComponent };